import React, { useState } from 'react';
import { Inbox, UserRound, Download } from 'lucide-react';
import { toast } from 'sonner';
import { useAdminSession } from '../../context/AdminSessionContext';
import { useAbortableTask } from '../../hooks/useAbortableTask';
import { AdminEmptyState, adminButtonClass, formatDate, downloadBlob } from './AdminShared';

const CONFIG = {
  demo: { table: 'admin-demo-table', row: 'admin-demo-row', export: 'demos', resource: 'demo-requests', filename: 'lawyah-demo-requests.csv', icon: Inbox, empty: 'noDemos', name: 'full_name', action: 'aiReview', fields: ['name', 'firm', 'email', 'phone', 'received', 'review'] },
  lead: { table: 'admin-leads-table', row: 'admin-lead-row', export: 'leads', resource: 'leads', filename: 'lawyah-chat-leads.csv', icon: UserRound, empty: 'noLeads', name: 'name', action: 'chatReview', fields: ['name', 'email', 'received', 'review'] },
};

export const AdminRecords = ({ kind, rows, copy, lang, onReview }) => {
  const config = CONFIG[kind];
  const { api } = useAdminSession();
  const [exporting, setExporting] = useState(false);
  const task = useAbortableTask();
  const exportRows = async () => {
    const operation = task.start(); setExporting(true);
    try {
      const blob = await api.download(`/export/${config.resource}`, operation.signal);
      if (task.isCurrent(operation)) { downloadBlob(blob, config.filename); toast.success(copy.exported); }
    } catch (error) { if (task.isCurrent(operation) && error.status !== 401) toast.error(copy.exportError); }
    finally { if (task.isCurrent(operation)) setExporting(false); }
  };
  return <><div className="mb-4 flex justify-end"><button onClick={exportRows} disabled={exporting} className={adminButtonClass} data-testid={`admin-export-${config.export}-button`}><Download className="h-4 w-4" />{copy.export}</button></div>
    {!rows.length ? <AdminEmptyState icon={config.icon} text={copy[config.empty]} /> : <div className="overflow-x-auto rounded-2xl border border-slate-200"><table className="w-full text-left text-sm" data-testid={config.table}>
      <thead className="bg-slate-50 text-xs uppercase text-slate-500"><tr>{config.fields.map(field => <th key={field} className="px-5 py-3.5 font-semibold">{copy[field]}</th>)}</tr></thead>
      <tbody>{rows.map(record => <tr key={record.id} data-testid={`${config.row}-${record.id}`} className="border-t border-slate-100">
        <td className="px-5 py-3.5 font-semibold">{record[config.name] || '—'}</td>
        {kind === 'demo' && <td className="px-5 py-3.5 text-slate-600">{record.firm_name || '—'}</td>}
        <td className="px-5 py-3.5 text-slate-600">{record.email}</td>
        {kind === 'demo' && <td className="px-5 py-3.5 text-slate-600">{record.phone || '—'}</td>}
        <td className="px-5 py-3.5 text-slate-500">{formatDate(record.created_at, lang)}</td>
        <td className="px-5 py-3.5"><button className="text-button" data-testid={`admin-review-${kind}-${record.id}`} onClick={() => onReview({ kind, id: record.id, session_id: record.session_id, title: record[config.name], details: record })}>{copy[config.action]}</button></td>
      </tr>)}</tbody>
    </table></div>}
  </>;
};